/**
 * Запросы дашборда поверх общего клиента `@/api`.
 *
 * Основные данные экрана приходят одним `useDashboard(period)`; здесь только
 * то, что подгружается по клику: выборка дел, раскрытая строка отделения
 * и выгрузка отчёта.
 */

import { downloadFile } from '@/api/client';
import { useDashboardDepartment, useDashboardList } from '@/api/hooks';
import { periodToParams } from '@/lib/deadlines';
import type { ListFilters, ListKpi, PeriodValue } from './types';

/** `GET /api/dashboard/list` — дела под предикатом плитки, ячейки, строки нагрузки. */
export function useCaseList(kpi: ListKpi | null, params: ListFilters | undefined, period: PeriodValue) {
    return useDashboardList(kpi === null ? null : { kpi, ...(params ?? {}) }, period);
}

/** `GET /api/dashboard/department/:id` — раскрытая строка блока отделений. */
export function useDepartmentDetail(departmentId: string | null, period: PeriodValue) {
    return useDashboardDepartment(departmentId, period);
}

/**
 * `GET /api/reports/summary.xlsx` — выгрузка отчёта за текущий период.
 * Качаем через blob (клиент делает это сам), чтобы запрос ушёл с cookie,
 * а ошибку можно было показать тостом, а не пустой вкладкой.
 */
export async function downloadReport(period: PeriodValue): Promise<void> {
    const params = periodToParams(period);
    const stamp = params.from && params.to ? `${params.from}-${params.to}` : `${params.days ?? 7}d`;
    await downloadFile('/reports/summary.xlsx', { ...params }, `gms-report-${stamp}.xlsx`);
}
